import React from "react";
import { ICustomBreadCrumbProps } from "./CustomBreadCrumbProps";
import { BreadCrumb } from "./CustomBreadCrumbHelpers";

const CustomBreadCrumb: React.FC<ICustomBreadCrumbProps> = (props) => {
  return (
    <BreadCrumb
      crumbs={props.crumbs}
      step={props.step}
      location={props.location}
      hotel={props.hotel}
      handleGoToGuestDetailsStep={props.handleGoToGuestDetailsStep}
    />
  );
};

export default CustomBreadCrumb;
